import { FC } from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as CheckCircleSmall } from 'assets/icons/CheckCircleSmall.svg';

import { ISelectOnePageStyleButtonProps } from './types';

import styles from './SelectOnePageStyleButton.module.scss';

export const SelectOnePageStyleButton: FC<ISelectOnePageStyleButtonProps> = ({
  isSelected,
  isAccessed,
  bgImage,
  onClick,
  isUpgradeTextShown = false,
}) => {
  const canAccess = !isAccessed && isUpgradeTextShown;

  return (
    <button
      className={clsx(styles['menu-button-wrapper'], {
        [styles['selected']]: isSelected,
        [styles['not-accessed']]: canAccess,
      })}
      style={{ backgroundImage: `url(${bgImage})` }}
      type="button"
      onClick={onClick}
    >
      {canAccess && (
        <Box className={styles['blur-overlay']}>
          <Typography className={styles['text']} variant="h6">
            Upgrade
          </Typography>
        </Box>
      )}
      {isSelected && <CheckCircleSmall className={styles['check-circle']} />}
    </button>
  );
};
